import { useEffect } from 'react';
import HeaderStyleTwo from '../Shared/HeaderStyleTwo';
import Footer from '../Shared/Footer';
import { LionPlayer } from 'lion-player';
import VolunteersBanner from '../Shared/VolunteersBanner';
const WaterHandPumps = () => {
  useEffect(() => {
    runJQueryScripts();
  }, []);

  const runJQueryScripts = () => {
    let tag: any;
    let loadScript = function (src: string) {
      tag = document.createElement('script');
      tag.async = false;
      tag.src = src;
      document.getElementsByTagName('body')[0].appendChild(tag);
    };
    loadScript('../assets/js/jquery.js');
    loadScript('../assets/js/popper.min.js');
    loadScript('../assets/js/jquery-ui.js');
    loadScript('../assets/js/jquery.fancybox.js');
    loadScript('../assets/js/owl.js');
    loadScript('../assets/js/appear.js');
    loadScript('../assets/js/wow.js');
    loadScript('../assets/js/lazyload.js');
    loadScript('../assets/js/scrollbar.js');
    loadScript('../assets/js/script.js');
    return () => {
      document.getElementsByTagName('body')[0].removeChild(tag);
    };
  };
  return (
    <>
      <HeaderStyleTwo />
      <div className='ulockd-inner-page'>
        <div className='container'>
          <div className='row'>
            <div className='col-md-12'>
              <div className='ulockd-icd-layer'>
                <ul className='list-inline ulockd-icd-sub-menu'>
                  <li>
                    <a style={{ color: '#25283a' }} href='/'>
                      {' '}
                      Home{' '}
                    </a>
                  </li>
                  <li>
                    <a style={{ color: '#25283a' }} href='#'>
                      <b> / </b>
                    </a>
                  </li>
                  <li>
                    {' '}
                    <a href='/water-hand-pumps'>Water Hand Pumps</a>{' '}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className='sidebar-page-container'
        style={{ padding: '50px 0px 0px' }}
      >
        <div className='auto-container'>
          <div className='row clearfix'>
            <div className='content-side col-lg-8 col-md-12 col-sm-12'>
              <div className='cause-details'>
                <div className='inner-box'>
                  <div className='image-box'>
                    <figure className='image'>
                      <a href='/get-involved'>
                        <img
                          className='lazy-image'
                          src='assets/images/resource/image-spacer-for-validation.png'
                          data-src='assets/images/resource/water-hand-pumps.jpg'
                          alt=''
                        />
                      </a>{' '}
                    </figure>
                  </div>

                  <div
                    className='lower-content'
                    style={{ padding: '40px 0 0' }}
                  >
                    <div className='text-content'>
                      <h2>
                        <a href='/get-involved'>Water Hand Pumps</a>
                      </h2>
                      <p>
                        Sadqa-E-Jariya Welfare Foundation is committed to
                        implementing clean water projects in Pakistan.
                      </p>
                      <p>
                        <b>Facts:</b>
                      </p>
                      <ul>
                        <li>
                          17.7 million Pakistanis have no choice but to drink
                          dirty water. (Water Aid Global)
                        </li>
                        <li>
                          An estimated 70 percent of households in Pakistan
                          still drink bacterially contaminated water. (UNICEF)
                        </li>
                        <li>
                          53,000 Pakistani children under five die annually from
                          diarrhea due to dirty water and poor sanitation.
                          (UNICEF)
                        </li>
                      </ul>

                      <p>
                        Alhamdulillah by the grace of <b>Allah Almighty</b>,
                        Sadqa-E-Jariya Welfare Foundation installed{' '}
                        <b>
                          {' '}
                          148 Water Hand Pumps & 8 Solar Pumps in low prevililage
                          areas{' '}
                        </b>{' '}
                        in Pakistan.
                      </p>
                      <section
                        className='news-section'
                        style={{ paddingTop: 0, paddingBottom: 20 }}
                      >
                        <div className='auto-container' style={{ padding: 0 }}>
                          <div className='row clearfix'>
                            <div className='news-block col-lg-12 col-md-12 col-sm-12'>
                              <div
                                className='inner-box wow fadeInUp'
                                data-wow-delay='0ms'
                              >
                                <div
                                  className='lower-content'
                                  style={{ padding: 5 }}
                                >
                                  <div id='video_block_one'>
                                    <div
                                      className='video-inner'
                                      style={{ padding: 5 }}
                                    >
                                      <LionPlayer
                                        sources={
                                          '../assets/video/water-hand-pumps/water-hand-pumps.mp4'
                                        }
                                      />
                                    </div>
                                  </div>
                                  {/* <h3>
                                    Free Grocery for Widows and Senior Citizen
                                  </h3> */}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                      <section className='insta-gallery'>
                        <div
                          className='insta-gallery-carousel love-carousel owl-theme owl-carousel'
                          data-options='{"loop": false, "margin": 0, "autoheight":true, "lazyload":true, "nav": true, "dots": true, "autoplay": true, "autoplayTimeout": 5000, "smartSpeed": 500, "responsive":{ "0" :{ "items": "1" },"600" :{ "items": "2" }, "768" :{ "items" : "3" }, "1024":{ "items" : "4" }, "1366":{ "items" : "4" }, "1500":{ "items" : "5" }, "1920":{ "items" : "6" }}}'
                        >
                          <div className='gallery-item'>
                            <div className='image-box'>
                              <figure className='image'>
                                <img
                                  className='lazy-image owl-lazy'
                                  src='assets/images/resource/image-spacer-for-validation.png'
                                  data-src='assets/images/gallery/thumbnail/water-hand-pumps-1.jpg'
                                  alt=''
                                />
                              </figure>
                              <div className='overlay-box'>
                                <a
                                  href='../assets/images/gallery/original/water-hand-pumps-1.jpg'
                                  className='lightbox-image'
                                  data-fancybox='gallery'
                                >
                                  <span className='icon flaticon-instagram'></span>
                                </a>
                              </div>
                            </div>
                          </div>

                          <div className='gallery-item'>
                            <div className='image-box'>
                              <figure className='image'>
                                <img
                                  className='lazy-image owl-lazy'
                                  src='assets/images/resource/image-spacer-for-validation.png'
                                  data-src='assets/images/gallery/thumbnail/water-hand-pumps-2.jpg'
                                  alt=''
                                />
                              </figure>
                              <div className='overlay-box'>
                                <a
                                  href='../assets/images/gallery/original/water-hand-pumps-2.jpg'
                                  className='lightbox-image'
                                  data-fancybox='gallery'
                                >
                                  <span className='icon flaticon-instagram'></span>
                                </a>
                              </div>
                            </div>
                          </div>

                          <div className='gallery-item'>
                            <div className='image-box'>
                              <figure className='image'>
                                <img
                                  className='lazy-image owl-lazy'
                                  src='assets/images/resource/image-spacer-for-validation.png'
                                  data-src='assets/images/gallery/thumbnail/water-hand-pumps-3.jpg'
                                  alt=''
                                />
                              </figure>
                              <div className='overlay-box'>
                                <a
                                  href='../assets/images/gallery/original/water-hand-pumps-3.jpg'
                                  className='lightbox-image'
                                  data-fancybox='gallery'
                                >
                                  <span className='icon flaticon-instagram'></span>
                                </a>
                              </div>
                            </div>
                          </div>

                          <div className='gallery-item'>
                            <div className='image-box'>
                              <figure className='image'>
                                <img
                                  className='lazy-image owl-lazy'
                                  src='assets/images/resource/image-spacer-for-validation.png'
                                  data-src='assets/images/gallery/thumbnail/water-hand-pumps-4.jpg'
                                  alt=''
                                />
                              </figure>
                              <div className='overlay-box'>
                                <a
                                  href='../assets/images/gallery/original/water-hand-pumps-4.jpg'
                                  className='lightbox-image'
                                  data-fancybox='gallery'
                                >
                                  <span className='icon flaticon-instagram'></span>
                                </a>
                              </div>
                            </div>
                          </div>

                          <div className='gallery-item'>
                            <div className='image-box'>
                              <figure className='image'>
                                <img
                                  className='lazy-image owl-lazy'
                                  src='assets/images/resource/image-spacer-for-validation.png'
                                  data-src='assets/images/gallery/thumbnail/water-hand-pumps-5.jpg'
                                  alt=''
                                />
                              </figure>
                              <div className='overlay-box'>
                                <a
                                  href='../assets/images/gallery/original/water-hand-pumps-5.jpg'
                                  className='lightbox-image'
                                  data-fancybox='gallery'
                                >
                                  <span className='icon flaticon-instagram'></span>
                                </a>
                              </div>
                            </div>
                          </div>

                          <div className='gallery-item'>
                            <div className='image-box'>
                              <figure className='image'>
                                <img
                                  className='lazy-image owl-lazy'
                                  src='assets/images/resource/image-spacer-for-validation.png'
                                  data-src='assets/images/gallery/thumbnail/water-hand-pumps-6.jpg'
                                  alt=''
                                />
                              </figure>
                              <div className='overlay-box'>
                                <a
                                  href='../assets/images/gallery/original/water-hand-pumps-6.jpg'
                                  className='lightbox-image'
                                  data-fancybox='gallery'
                                >
                                  <span className='icon flaticon-instagram'></span>
                                </a>
                              </div>
                            </div>
                          </div>
                          <div className='gallery-item'>
                            <div className='image-box'>
                              <figure className='image'>
                                <img
                                  className='lazy-image owl-lazy'
                                  src='assets/images/resource/image-spacer-for-validation.png'
                                  data-src='assets/images/gallery/thumbnail/water-hand-pumps-7.jpg'
                                  alt=''
                                />
                              </figure>
                              <div className='overlay-box'>
                                <a
                                  href='../assets/images/gallery/original/water-hand-pumps-7.jpg'
                                  className='lightbox-image'
                                  data-fancybox='gallery'
                                >
                                  <span className='icon flaticon-instagram'></span>
                                </a>
                              </div>
                            </div>
                          </div>
                          <div className='gallery-item'>
                            <div className='image-box'>
                              <figure className='image'>
                                <img
                                  className='lazy-image owl-lazy'
                                  src='assets/images/resource/image-spacer-for-validation.png'
                                  data-src='assets/images/gallery/thumbnail/water-hand-pumps-8.jpg'
                                  alt=''
                                />
                              </figure>
                              <div className='overlay-box'>
                                <a
                                  href='../assets/images/gallery/original/water-hand-pumps-8.jpg'
                                  className='lightbox-image'
                                  data-fancybox='gallery'
                                >
                                  <span className='icon flaticon-instagram'></span>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                      <br />
                      <p>
                        Invest your money to gain pleasure of <b>ALLAH</b>.
                      </p>
                      <br />
                      <h3>Your help turns into smiles.</h3>
                    </div>
                    <div className='link-box'>
                      <a
                        href='/get-involved'
                        className='theme-btn btn-style-one'
                      >
                        <span className='btn-title'>Donate Now</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className='sidebar-side col-lg-4 col-md-12 col-sm-12'>
              <aside className='sidebar'>
                <div className='sidebar-widget categories'>
                  <div className='text'>
                    <b>
                      You can be a part of the change in this world. Give a
                      helping hand to those who need it!
                    </b>
                  </div>

                  <h3 className='sidebar-title'>Our Programs</h3>
                  <div className='widget-content'>
                    <ul>
                      <li className='current'>
                        <a href='/water-hand-pumps'>
                          Clean Water Program (Water Hand Pumps)
                        </a>
                      </li>
                      <li>
                        <a href='/free-grocery-for-widows-and-senior-citizen'>
                          Free Grocery for Widows and Senior Citizen
                        </a>
                      </li>
                      <li>
                        <a href='/apna-rozgar'>
                          Apna Rozgar (Small Business Setups)
                        </a>
                      </li>
                      <li>
                        <a href='/medical-support'>Free Medical Support</a>
                      </li>
                      <li>
                        <a href='/basic-schools'>
                          Free Education for Child (Basic Schools)
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </aside>
            </div>
          </div>
        </div>
      </div>
      {/* <VolunteersBanner /> */}
      <Footer />
    </>
  );
};
export default WaterHandPumps;
